import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsEBikeRideNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M40.168.748l-5.131 7.697A1 1 0 0035.869 10H40v4.697c0 .99 1.283 1.378 1.832.555l5.132-7.697A1 1 0 0046.132 6H42V1.303c0-.99-1.283-1.378-1.832-.555zM27.224 13.711A1.5 1.5 0 0128.5 13H36v3h-5.073l4.718 9.436a9.5 9.5 0 11-2.682 1.343l-2.31-4.619-7.867 13.112A1.5 1.5 0 0121.5 36h-2.618c-.719 4.534-4.646 8-9.382 8a9.5 9.5 0 112.855-18.564l1.92-3.84L13.346 20H10v-3h10v3h-3.183l5.727 9.844 6.519-10.864-1.905-3.81a1.5 1.5 0 01.066-1.459zM11.927 33h8.724l.131-.22-4.703-8.084zm-.94-4.83A6.5 6.5 0 1015.826 36H9.5a1.5 1.5 0 01-1.342-2.17zm23.343 1.344a6.5 6.5 0 102.683-1.343l3.5 7-2.684 1.341z" />
      </g>
    </svg>
  )
);
SvgSportsEBikeRideNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsEBikeRideNormalLarge;
